<template>
  <div class="flex min-h-screen bg-primaryBg font-inter">
    <aside class="hidden md:block w-[294px] flex-shrink-0 bg-primaryBg text-primaryDark">
      <Sidebar />
    </aside>
    <div class="flex-grow">
      <main class="w-full">
        <ActivityData />
      </main>
      </div>
    </div>
  </template>
  
  <script>
  import Sidebar from '@/components/SidebarComponent.vue';
  import ActivityData from '@/components/project/ActivityData.vue';
  
  export default {
    name: 'ActivityDataView',
    components: {
      Sidebar,
      ActivityData
    },
    mounted() {
    window.scrollTo(0, 0);
    },
  }
  </script>
  <style scoped>
  .smoke-light {
    background-color: rgba(0, 0, 0, 0.5);
  }
  </style>
  